"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getTimeZone() {
    if (typeof Intl === 'undefined')
        return;
    return Intl?.DateTimeFormat().resolvedOptions().timeZone;
}
exports.default = getTimeZone;
//# sourceMappingURL=getTimeZone.js.map